import { Icon, IconButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { MoreHorizontal, Pin, PinOff } from 'lucide-react';
import { Trans } from '@lingui/react/macro';
import { useCallback } from 'react';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';

interface NoteActionsProps {
  noteId: string;
  isPinned?: boolean;
}

export function NoteActions({ noteId, isPinned = false }: NoteActionsProps) {
  const trpcUtils = trpcAdmin.useUtils();

  const pinAdminNote = trpcAdmin.students.pinAdminNote.useMutation({
    onSuccess: () => {
      void trpcUtils.students.adminNotes.invalidate();
      void trpcUtils.students.pinnedNotesCount.invalidate();
    },
  });

  const unpinAdminNote = trpcAdmin.students.unpinAdminNote.useMutation({
    onSuccess: () => {
      void trpcUtils.students.adminNotes.invalidate();
      void trpcUtils.students.pinnedNotesCount.invalidate();
    },
  });

  const handlePin = useCallback(() => {
    pinAdminNote.mutate({ note_id: noteId });
  }, [noteId]);

  const handleUnpin = useCallback(() => {
    unpinAdminNote.mutate({ note_id: noteId });
  }, [noteId]);

  return (
    <Menu>
      <MenuButton as={IconButton} variant="ghost" size="xs">
        <Icon as={MoreHorizontal} />
      </MenuButton>
      <MenuList>
        {isPinned ? (
          <MenuItem gap="10px" color="fg.emphasis" onClick={handleUnpin}>
            <Icon as={PinOff} />
            <Trans>Unpin note</Trans>
          </MenuItem>
        ) : (
          <MenuItem gap="10px" color="fg.emphasis" onClick={handlePin}>
            <Icon as={Pin} />
            <Trans>Pin note</Trans>
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  );
}
